var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FEE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.25 13.3852C8.25 12.7425 8.52483 12.1305 9.00518 11.7035L13.0069 8.14644C14.1436 7.13608 15.8564 7.13608 16.9931 8.14644L20.9948 11.7035C21.4752 12.1305 21.75 12.7425 21.75 13.3852L21.75 19.4998C21.75 21.1567 20.4069 22.4998 18.75 22.4998H11.25C9.59315 22.4998 8.25 21.1567 8.25 19.4998L8.25 13.3852Z",
    fill: "#DE8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C12 17.8431 13.3431 16.5 15 16.5C16.6569 16.5 18 17.8431 18 19.5V22.5H12L12 19.5Z",
    fill: "#DE8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAddress);
export default __webpack_public_path__ + "static/media/menu_address.5978ade4e6ce956eaa9ae45286c5e849.svg";
export { ForwardRef as ReactComponent };